import React from 'react';
import { useListContext } from 'react-admin';
import EventListSearchBar from '../events/EventListSearchBar';

/**
 * React-admin List içinde EventListSearchBar (yaklaşan etkinlikler tasarımı).
 * `q` filter parametresini set eder.
 */
const ListQSearchBar = ({
  placeholder,
  placeholderKey = 'form.search_placeholder',
  source = 'q',
}) => {
  const { filterValues, setFilters, displayedFilters, isFetching } = useListContext();
  const value =
    filterValues && typeof filterValues[source] === 'string' ? filterValues[source] : '';

  const apply = (nextQ) => {
    const next = { ...(filterValues || {}) };
    const cleaned = (nextQ || '').trim();
    if (cleaned) next[source] = cleaned;
    else delete next[source];
    setFilters(next, displayedFilters);
  };

  return (
    <EventListSearchBar
      value={value}
      onSearch={apply}
      onClear={() => apply('')}
      disabled={isFetching}
      placeholder={placeholder}
      placeholderKey={placeholderKey}
    />
  );
};

export default ListQSearchBar;
